import * as TypeUtil from './TypeUtil'

export function get(key,force=false) {
  if (TypeUtil.isNonEmptyString(key)) {
    const value = localStorage.getItem(key)
    if (TypeUtil.isNonEmptyString(value)) {
      try {
        const o = JSON.parse(value)
        if (TypeUtil.isObject(o)) {
          const type = o.type
          const value = o.value
          if (force) {
            return value
          }
          if (TypeUtil.isNonEmptyString(type)) {
            if (type==='object') {
              if (TypeUtil.isObject(value)) {
                return value
              }
            } else if (type==='number') {
              if (TypeUtil.isNumber(value)) {
                return value
              }
            } else if (type==='string') {
              if (TypeUtil.isString(value)) {
                return value
              }
            }
          }
        }
      } catch(e) {
      }
    }
  }
  return undefined
}

export function set(key, value) {
  if (TypeUtil.isNonEmptyString(key)) {
    if (value===undefined) {
      remove(key)
    } else {
      const type = typeof(value)
      if (['object','number','string'].includes(type)) {
        localStorage.setItem(key, JSON.stringify({
          type: type,
          value: value,
        }))
      }
    }
  }
}

export function remove(key) {
  if (TypeUtil.isNonEmptyString(key)) {
    localStorage.removeItem(key)
  }
}
